// extracted by mini-css-extract-plugin
module.exports = {"container":"error503_container__18iLO","logo":"error503_logo__2Dd7u","iconContainer":"error503_iconContainer__1029-","icon":"error503_icon__ManB-","title":"error503_title__3DD5B"};